import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_OUTLET_FILTERS, GET_OUTLET_FILTERS_ERROR, GET_OUTLET_FILTERS_SUCCESS } from '../../actions.js';

function* getOutletFilters() {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/vendor/digital/outlet-filters`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_OUTLET_FILTERS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_OUTLET_FILTERS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_OUTLET_FILTERS_ERROR, payload: error });
  }
}

export function* watchGetOutletFilters() {
  yield takeEvery(GET_OUTLET_FILTERS, getOutletFilters);
}

function* getOutletFiltersSaga() {
  yield all([fork(watchGetOutletFilters)]);
}

export default getOutletFiltersSaga;
